import { useLayoutEffect, useEffect } from "react";
const isJSDom = typeof navigator !== "undefined" && navigator?.userAgent?.includes("jsdom");
const useIsomorphicLayoutEffect = typeof document !== "undefined" && !isJSDom ? useLayoutEffect : useEffect;
export {
  useIsomorphicLayoutEffect
};
